// export const Roboto = "serif";
export const Roboto = "Roboto";
export const materialSymbolsOutlined = "Material Symbols Outlined";
export const inter = "Inter";
